
    <div class="col-md-12 bg-white no-padding">
        <app-sidebar-content></app-sidebar-content>
    </div>
